import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import ConfirmDefaultActivationModal from "app/pages/activation/components/ConfirmDefaultActivationModal/ConfirmDefaultActivationModal";
import {
    alreadyAsDefaultTextContainer,
    setAsDefaultHomePageButton,
} from "app/pages/activation/components/Settings/SetDefaultHomePageButton/dataAutomationKeys";
import {
    ALREADY_DEFAULT_HOME_PAGE_BUTTON_TEXT,
    SET_AS_DEFAULT_HOME_PAGE_BUTTON_TEXT,
} from "app/pages/activation/components/Settings/SetDefaultHomePageButton/texts";
import useDefaultActivation from "app/pages/activation/hooks/settings/useDefaultActivation";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import * as SC from "./styles";

const { blue } = colorsPalettes;

type SetDefaultHomePageButtonSchema = {
    activationName: string;
};

export const SetDefaultHomePageButton = ({ activationName }: SetDefaultHomePageButtonSchema) => {
    const { key: activationId, country } = proNavigator.getApiParams();

    const {
        setDefaultPage,
        setIsConfirmModalOpen,
        updateDefaultActivation,
        selectedActivationData,
        isConfirmModalOpen,
        defaultActivationId,
        isLoading: isDefaultActivation,
    } = useDefaultActivation();

    const onClick = () => {
        setDefaultPage({ activationId, name: activationName, country });
    };

    const onCloseClick = () => {
        setIsConfirmModalOpen(false);
    };

    return (
        <>
            {defaultActivationId === activationId ? (
                <SC.AllReadySetDefaultContainer data-automation={alreadyAsDefaultTextContainer}>
                    <SWReactIcons
                        iconName="star"
                        size="xs"
                        iconColor={blue[400]}
                    />

                    <SC.DefaultText>{translate(ALREADY_DEFAULT_HOME_PAGE_BUTTON_TEXT)}</SC.DefaultText>
                </SC.AllReadySetDefaultContainer>
            ) : (
                <IconButton
                    iconName="star-outline"
                    iconColor={blue[400]}
                    iconSize="xs"
                    type="outlined"
                    onClick={onClick}
                    dataAutomation={setAsDefaultHomePageButton}
                >
                    {translate(SET_AS_DEFAULT_HOME_PAGE_BUTTON_TEXT)}
                </IconButton>
            )}

            <ConfirmDefaultActivationModal
                isOpen={isConfirmModalOpen}
                onUpdateDefaultActivation={updateDefaultActivation}
                onCloseClick={onCloseClick}
                isLoading={isDefaultActivation}
                selectedName={selectedActivationData?.name}
            />
        </>
    );
};
